<template>
    <div class="vote-content-container">
        <div class="title">
            <h3 class="text-center">{{ vote.title }}</h3>
            <h5 class="mt-4 text-center">（参与人数：{{ records.length }} 人）</h5>
        </div>

        <div class="items-container">
            <div class="item" v-for="(item, index) in items" :key="index">
                <div class="option-row" :class="{ selected: isSelected(item.id) }"
                     @click="handleItemClick(item.id)">

                    <div class="progress" v-if="records.length"
                         :style="{width: optionProgress(item.id)}"></div>

                    <div class="select-icon" v-if="!isLecturer">
                        <i class="icon icon-radio"></i>
                    </div>
                    <div class="image" v-if="item.image" @click="previewImage(item.image_url)">
                        <img :src="item.image_url" alt="">
                    </div>
                    <div class="title">
                        {{ item.title }}
                    </div>
                    <div class="vote-num">
                        <span>{{ optionProgress(item.id) }}</span> <span class="ml-3">{{
                            optionTotal(item.id)
                                                                                      }} 票</span>
                    </div>
                </div>
                <div v-if="isLecturer && showUserList == item.id && optionUsers(item.id).length" class="users">
                    <div class="">投此票的人员</div>
                    <div class="items">
                        <div v-for="user in optionUsers(item.id)">
                            <div class="item">
                                <img class="avatar" :src="user.user.avatar_url" alt="">
                                <div class="info">
                                    <div>{{ user.user.name }}</div>
                                    <div>{{ getDate(user.user.created_at) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="btn-container">
            <button v-if="!isLecturer && !isSubmitted" type="button" class="btn btn-success no-radius" @click="submit"
                    :disabled="selected.length <= 0">
                投票
            </button>
            <button v-if="!isLecturer && isSubmitted" type="button" class="btn btn-warning no-radius">
                已投票
            </button>

            <button v-if="isLecturer" type="button" class="btn no-radius"
                    :class="[vote.status == 1 ? 'btn-danger' : 'btn-success']" @click="updateStatus">
                {{ vote.status == 1 ? '结束投票' : '开启投票' }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "VoteContent",
    props: {
        vote: {
            type: Object
        },
        isLecturer: {
            type: Number
        },
        submitUrl: {
            type: String
        },
        updateStatusUrl: {
            type: String
        },
        records: {
            type: Array,
            default: () => {
                return []
            }
        },
        userRecord: {
            type: Object,
            default: null
        }
    },
    filters: {},
    data() {
        return {
            type: 0,
            items: [],
            selected: [],
            showUserList: 0
        }
    },
    computed: {
        isSubmitted() {
            return !!this.userRecord
        },
        optionTotal() {
            return function (val) {
                return this.records.filter(rec => rec.content.includes(val)).length;
            }
        },
        optionUsers() {
            return function (val) {
                return this.records.filter(rec => rec.content.includes(val))
            }
        },
        optionProgress() {
            return function (val) {
                return this.records.length == 0 ? '0%' : `${(this.optionTotal(val) / this.records.length * 100).toFixed(2)}%`
            }
        }
    },
    mounted() {
        this.type = parseInt(this.vote.options.type) || 0
        this.items = this.vote.training_interaction_vote || []
        this.selected = this.userRecord ? this.userRecord.content.split(',').map(rec => +rec) : []
    },
    methods: {
        handleItemClick(itemId) {
            this.isLecturer ? this.showUsers(itemId) : this.selectItem(itemId)
        },
        isSelected(val) {
            return !this.isLecturer && this.selected.indexOf(val) > -1
        },
        selectItem(val) {
            if (this.isLecturer === 1 || this.isSubmitted) {
                return
            }
            if (this.type == 0) {
                this.selected = [val];
            } else {
                this.isSelected(val) ? this.selected.splice(this.selected.indexOf(val), 1) : this.selected.push(val);
            }
        },
        showUsers(val) {
            this.showUserList = this.showUserList == val ? 0 : val
        },
        submit() {
            layer.load()

            const formData = {
                content: this.selected
            }

            $.ajax({
                type: 'POST',
                url: this.submitUrl,
                data: JSON.stringify(formData),
                contentType: 'application/json',
                success: common.ajax_callback,
                error: common.error
            })
        },
        updateStatus() {
            $.ajax({
                type: 'PUT',
                url: this.updateStatusUrl,
                data: {},
                contentType: 'application/json',
                success: common.ajax_callback,
                error: common.error
            })
        },
        getDate(val) {
            const arr = val.split(' ')

            return arr[0]
        },
        previewImage(src) {
            layer.open({
                skin: 'image-preview',
                area: ['600px', '600px'],
                content: `<img src="${src}" alt="" style="width: 100%;height: 100%">`,
                title: false,
                btn: false,
                resize: false,
                move: false,
                shadeClose: true,
                closeBtn: 0
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.vote-content-container {
    .items-container {
        margin-top: 30px;
        padding: 20px 50px;
        background-color: white;

        .item {
            &:not(:last-child) {
                margin-bottom: 20px;
            }

            .option-row {
                background-color: #f3f5f7;
                padding: 15px 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 60px;
                position: relative;
                cursor: pointer;
                z-index: 5;

                .progress {
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    background-color: #f8e5c7;
                    border-radius: 0;
                    z-index: -1;
                }

                &.selected {
                    border: 2px solid #ffa028;

                    .select-icon {
                        i {
                            color: #ffa028;
                        }
                    }
                }

                .select-icon {
                    position: absolute;
                    left: -11px;
                    border-radius: 50%;
                    z-index: 2;

                    i {
                        background-color: white;
                        border-radius: 50%;
                        font-size: 20px;
                        color: #ccc;
                    }
                }

                .image {
                    img {
                        width: 40px;
                        height: 40px;
                    }

                    margin-right: 5px;
                }

                .title {
                    flex: 1;
                }
            }

            .users {
                border: 2px solid #f3f5f7;
                padding: 0 10px 10px;

                .items {
                    display: flex;
                    margin-top: 5px;

                    .item {
                        display: flex;
                        align-items: center;
                        margin-right: 10px;
                        flex-wrap: wrap;

                        .avatar {
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                        }

                        .info {
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
    }

    .btn-container {
        text-align: center;
        margin-top: 30px;

        .btn {
            font-size: 18px;
            padding: 12px 50px;
        }
    }
}
</style>
